/** Copyright 2024 SAP SE or an SAP affiliate company. All rights reserved. */

import { createStyles } from '@/utils/styles';
import { FlexBox, Icon } from '@ui5/webcomponents-react';
import { ThemingParameters } from '@ui5/webcomponents-react-base';

import '@ui5/webcomponents-icons/dist/tree.js';
import '@ui5/webcomponents-icons/dist/it-system.js';
import '@ui5/webcomponents-icons/dist/ppt-attachment.js';

const styles = createStyles({
    wrapper: {
        margin: '2rem',
        padding: ThemingParameters.sapContent_Padding_M,
        backgroundColor: ThemingParameters.sapAvatar_6_Background,
        borderRadius: ThemingParameters.sapElement_BorderCornerRadius,
    },
    icon: {
        width: '3rem',
        height: '3rem',
        color: ThemingParameters.sapAvatar_6_TextColor,
    },
});

type TaskIconProps = {
    icon: string;
};

const TaskIcon: React.FC<TaskIconProps> = ({ icon }) => {
    const isRelativeUrl = icon.startsWith('/images');
    if (isRelativeUrl) {
        return <img className="questionImage imgWithPadding" src={icon} alt="card logo" />;
    }

    return (
        <FlexBox style={styles.wrapper}>
            <Icon style={styles.icon} name={icon} />
        </FlexBox>
    );
};

export default TaskIcon;
